/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Header_Personal_PanelInputs */

const es_admin_header_personal_panel = /** @type {(inputs: Admin_Header_Personal_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel personal`)
};

const en_admin_header_personal_panel = /** @type {(inputs: Admin_Header_Personal_PanelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal panel`)
};

/**
* | output |
* | --- |
* | "Personal panel" |
*
* @param {Admin_Header_Personal_PanelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_header_personal_panel = /** @type {((inputs?: Admin_Header_Personal_PanelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Header_Personal_PanelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_header_personal_panel(inputs)
	return en_admin_header_personal_panel(inputs)
});
export { admin_header_personal_panel as "admin.header.personal_panel" }